/**
 * ImpersonationBanner — orange strip at the top of AppLayout when an
 * impersonation target is active. Stays visible until cleared.
 */

import { makeStyles, tokens, Button } from '@fluentui/react-components'
import { Dismiss20Regular, Eye20Regular } from '@fluentui/react-icons'
import { useImpersonation } from '../context/ImpersonationContext'

const useStyles = makeStyles({
  bar: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalL}`,
    background: '#fff4e5',
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
    borderBottomColor: '#e65100',
    color: '#7a3900',
    fontSize: '13px',
    fontWeight: 600,
  },
  spacer: { flex: 1 },
})

export function ImpersonationBanner() {
  const styles = useStyles()
  const { target, clearTarget } = useImpersonation()
  if (!target) return null

  return (
    <div className={styles.bar} role="alert" aria-live="polite">
      <Eye20Regular />
      <span>
        Viewing as <strong>{target.name}</strong> ({target.role}
        {target.focus_area_code ? ` · ${target.focus_area_code}` : ''})
      </span>
      <div className={styles.spacer} />
      <Button
        size="small"
        appearance="primary"
        icon={<Dismiss20Regular />}
        onClick={clearTarget}
      >
        Stop impersonating
      </Button>
    </div>
  )
}
